import { render, staticRenderFns } from "./home-forum.vue?vue&type=template&id=566d7130&scoped=true&"
import script from "./home-forum.vue?vue&type=script&lang=js&"
export * from "./home-forum.vue?vue&type=script&lang=js&"
import style0 from "./home-forum.vue?vue&type=style&index=0&id=566d7130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d7130",
  null
  
)

export default component.exports